module.exports = __webpack_public_path__ + "img/arms.a08f9ac8.jpg";